/* eslint-disable */
export default {
  removeParticipant: 'Teilnehmer entfernen',
  confirmStr1: 'Möchten Sie wirklich',
  confirmStr2: 'aus diesem Anruf entfernen?',
  remove: 'Entfernen',
  cancel: 'Abbrechen',
  participants: 'Teilnehmer',
  participant: 'Teilnehmer',
  conferenceCall: 'Telefonkonferenz',
  unknownNumber: 'Anonym',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
